import {createReducer, createTypes} from 'reduxsauce'
import {merge} from 'ramda'
import api from '../Services/api'
import {createCelulasPayload} from '../Celula/transformers'
import {filterByIgreja} from '../Celula/filters'
import {isAuthenticated} from './appRedux'

const types = createTypes(`
  FETCH_CELULAS
  START_FILTER_CELULAS
  FILTER_CELULAS
`)
export const celulaTypes = types

export default {
  fetchCelulas: () => (dispatch, getState) => {
    const celulas = isAuthenticated(getState()) ? 
       api.fetchPrivateCelulas() : api.fetchPublicCelulas()
    celulas.then(res => {
      let payload = res.data
      if (res.ok) {
        payload = createCelulasPayload(payload.values)
      }
      dispatch({
        type: types.FETCH_CELULAS,
        payload,
        error: !res.ok
      })
    })
  },
  filter: () => (dispatch, getState) => {
    const {filter, celula} = getState()
    dispatch({type: types.START_FILTER_CELULAS})
    const filtered = celula.values.filter(celula => {
      return (!filter.igreja && !filter.labels) ||
        ((!filter.igreja || filterByIgreja(filter.igreja, celula))
          && (!filter.labels || celula.labelsDescription === filter.labels))
    })
    dispatch({type: types.FILTER_CELULAS, payload: filtered})
  }
}

const initialState = {
  values: [],
  inProgress: false,
  filtered: [],
  labelsDescriptions: {}
}

const fetchCelulas = (state, {payload, error}) => {
  if (error) return state
  return merge(state, {
    values: payload.celulas,
    filtered: payload.celulas,
    labelsDescriptions: payload.labelsDescriptions
  })
}

const filter = (state, {payload}) => {
  return merge(state, {filtered: payload, inProgress: false})
}

export const reducer  = createReducer(initialState, {
  [types.FETCH_CELULAS]: fetchCelulas,
  [types.START_FILTER_CELULAS]: state => merge(state, {inProgress: true}),
  [types.FILTER_CELULAS]: filter
})


export const selectLabelDescriptions = state => {
  const labelsDescriptions = state.celula.labelsDescriptions
  return Object.keys(labelsDescriptions)
    .map(description => ({
      description,
      color: labelsDescriptions[description]
    }))
}



// WEBPACK FOOTER //
// ./src/Redux/celulaRedux.js